/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// import Geolocation from '@react-native-community/geolocation';
// import { Platform } from 'react-native';
// import { check, PERMISSIONS, request, RESULTS } from 'react-native-permissions';
// import { setLocation } from '@uhg-uhc-mobile/federation';

export type LocationCoords = { latitude: number; longitude: number };
export type LocationPermissionStatus = 'granted' | 'denied' | 'blocked';

export const requestLocationPermission = async (): Promise<LocationPermissionStatus> => {
  const permission =
    Platform.OS === 'ios'
      ? PERMISSIONS.IOS.LOCATION_WHEN_IN_USE
      : PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION;

  const current = await check(permission);

  if (current === RESULTS.GRANTED) {
    return 'granted';
  }

  if (current === RESULTS.BLOCKED) {
    return 'blocked';
  }

  const result = await request(permission);

  if (result === RESULTS.GRANTED) {
    return 'granted';
  }

  if (result === RESULTS.BLOCKED) {
    return 'blocked';
  }

  return 'denied';
};

const getDeviceLocation = (): Promise<LocationCoords> =>
  new Promise((resolve, reject) => {
    Geolocation.getCurrentPosition(
      (position: { coords: { latitude: number; longitude: number } }) =>
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }),
      (error: unknown) => reject(error),
      { enableHighAccuracy: false, timeout: 3000 },
    );
  });

export const getCurrentLocation = async (): Promise<LocationCoords | null> => {
  try {
    const status = await requestLocationPermission();

    if (status !== 'granted') {
      return null;
    }

    const coords = await getDeviceLocation();

    // Sync device location into the federation store so useLocation() consumers are up to date
    setLocation({ position: { lat: coords.latitude, lng: coords.longitude } });

    return coords;
  } catch {
    return null;
  }
};
